"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DOMPurify = require("dompurify");
exports.Purify = {
    sanitize: function (raw, tags) {
        if (DOMPurify.isSupported === false) {
            if (process.env.NODE_ENV === 'production') {
                throw new Error('Sanitize does not work in non DOM environments-- do not run this in production');
            }
            return raw;
        }
        return DOMPurify.sanitize(raw, tags);
    },
};
exports.default = exports.Purify;
//# sourceMappingURL=universal_purify.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/universal_purify.js
// module id = 6VqX
// module chunks = 20 21